<template>
  <!--pageLoadingComplete 页面加载完毕判定-->
  <div v-if="pageLoadingComplete" class="container-wrapper" :class="is_buy ? 'container-buy' : ''">
    <!-- 已购买 -->
    <div class="goods-infor" v-if="is_buy">
      <div class="banner-img">
        <img src="@/assets/images/shop/icon16.png" @click="show = true" />
      </div>
      <div class="goods-card container">
        <GoodsInfoTitle :title="goodInforTitle" />
        <div class="labels-title" style="border-bottom: 0; padding-bottom: 0.2rem">
          <span style="color: var(--main-color)">「{{ goodsData.tag_text }}」</span>
          {{ goodsData.intro }}
        </div>
      </div>
    </div>
    <!-- 未购买 -->
    <div class="goods-infor" v-else>
      <div class="banner-img">
        <img src="@/assets/images/shop/icon16.png" @click="show = true" />
      </div>
      <div class="goods-card container">
        <GoodsInfoTitle :title="goodInforTitle" :prefixText="goodsData.prefix_text" />
        <div class="labels-title">
          <span style="color: var(--main-color)">「{{ goodsData.tag_text }}」</span>
          {{ goodsData.intro }}
        </div>
        <div class="application-box">
          <div class="left">
            <div class="money-box">
              <div class="money-f" v-if="goodsData.product.price">
                <span>￥</span>
                {{
                  goodsData.product.price == 0 ? '免费' : clearPriceZero(goodsData.product.price)
                }}
              </div>
              <div class="money-r" v-if="goodsData.product.price && goodsData.product.price == 0">
                ￥{{ clearPriceZero(goodsData.product.o_price) }}
              </div>
            </div>
            <div class="refund-money">{{ goodsData.complate_reward_text }}</div>
          </div>
          <div class="right" @click="buy">报名加入</div>
        </div>
      </div>
    </div>

    <div class="goods-content">
      <van-tabs v-model="tabsActiveIndex" :scrollspy="!is_buy" sticky class="jbc-tabs"
        :class="tabsList.length <= 1 ? 'hideTabNav' : ''">
        <van-tab v-for="(item, index) in tabsList" :title="item.name" :key="index">
          <!-- 商品目录 -->
          <!-- 已购买 -->
          <template #title>
            <div class="" style="position: relative">
              <!-- <div class="audition-img" v-if="goodsData.has_free == 1 && index == 1">试听</div> -->
              {{ item.name }}
            </div>
          </template>

          <!-- 未购买 -->
          <template>
            <!-- 课程表相关 -->
            <template v-if="item.listKey === 'first_learn_content'">
              <div class="tab-box" v-if="goodsData.first_learn_content.length"
                :style="is_buy ? 'margin-top: 0.4rem;' : ''">
                <div class="tab-lists">
                  <div class="tab-list-item" @click="tabChange(item.key, index)"
                    :class="tab_active == index ? 'active' : ''" v-for="(item, index) in goodsData.first_learn_content"
                    :key="index">
                    {{ item.short_name }}
                  </div>
                </div>
              </div>
              <div class="container">
                <div class="collapse-list" v-if="learnList.length">
                  <van-collapse v-model="activeNames" class="border-s" v-for="(item, index) in learnList" :key="index"
                    :class="{ bg_gray: activeNames.includes(item.key) }" @change="collapseChange()">
                    <van-collapse-item :name="item.key" default>
                      <template #title>
                        <div class="title1">
                          {{ item.name }}
                          <div v-if="audition(item)" class="audition-box">
                            <svg class="my-color-class" width="7px" height="8px" viewBox="0 0 7 8" version="1.1"
                              xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                              <g id="页面-1">
                                <g id="学习目录1.0.4" transform="translate(-141.000000, -582.000000)">
                                  <g id="内容" transform="translate(0.000000, 142.000000)">
                                    <g id="5" transform="translate(16.000000, 274.000000)">
                                      <g id="章3" transform="translate(12.000000, 160.000000)">
                                        <g id="试听标签" transform="translate(109.000000, 2.000000)">
                                          <g id="icon/试听" transform="translate(4.000000, 4.000000)">
                                            <rect id="矩形-3227" opacity="0" x="0" y="0" width="7" height="8"></rect>
                                            <path
                                              d="M4.79999979,2.56666664 L6.54999991,4.89999998 C6.88137077,5.34182777 6.79182774,5.96862912 6.34999995,6.29999998 C6.17690377,6.42982212 5.96637015,6.5 5.74999992,6.5 L2.24999992,6.5 C1.69771517,6.5 1.24999992,6.05228475 1.24999992,5.5 C1.24999992,5.2836298 1.32017779,5.07309619 1.44999991,4.90000002 L3.19999979,2.56666669 C3.53137063,2.12483888 4.15817198,2.03529581 4.59999979,2.36666665 C4.67580546,2.4235209 4.74314554,2.49086098 4.79999979,2.56666664 Z"
                                              id="多边形-131"
                                              transform="translate(4.000000, 4.000000) rotate(90.000000) translate(-4.000000, -4.000000) ">
                                            </path>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                            试听
                          </div>
                        </div>
                      </template>
                      <template #right-icon>
                        <img src="@/assets/images/shop/icon1.png" class="icon-1" />
                      </template>
                      <van-collapse v-model="activeNames" :border="false">
                        <van-collapse-item :name="ite.key" class="items" v-for="(ite, index) in item.children_list"
                          :key="index">
                          <template #title>
                            <div class="title2">
                              {{ ite.name }}
                              <div v-if="audition(ite)" class="audition-box">
                                <svg class="my-color-class" width="7px" height="8px" viewBox="0 0 7 8" version="1.1"
                                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                  <g id="页面-1">
                                    <g id="学习目录1.0.4" transform="translate(-141.000000, -582.000000)">
                                      <g id="内容" transform="translate(0.000000, 142.000000)">
                                        <g id="5" transform="translate(16.000000, 274.000000)">
                                          <g id="章3" transform="translate(12.000000, 160.000000)">
                                            <g id="试听标签" transform="translate(109.000000, 2.000000)">
                                              <g id="icon/试听" transform="translate(4.000000, 4.000000)">
                                                <rect id="矩形-3227" opacity="0" x="0" y="0" width="7" height="8"></rect>
                                                <path
                                                  d="M4.79999979,2.56666664 L6.54999991,4.89999998 C6.88137077,5.34182777 6.79182774,5.96862912 6.34999995,6.29999998 C6.17690377,6.42982212 5.96637015,6.5 5.74999992,6.5 L2.24999992,6.5 C1.69771517,6.5 1.24999992,6.05228475 1.24999992,5.5 C1.24999992,5.2836298 1.32017779,5.07309619 1.44999991,4.90000002 L3.19999979,2.56666669 C3.53137063,2.12483888 4.15817198,2.03529581 4.59999979,2.36666665 C4.67580546,2.4235209 4.74314554,2.49086098 4.79999979,2.56666664 Z"
                                                  id="多边形-131"
                                                  transform="translate(4.000000, 4.000000) rotate(90.000000) translate(-4.000000, -4.000000) ">
                                                </path>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </g>
                                </svg>
                                试听
                              </div>
                            </div>
                          </template>
                          <template #right-icon>
                            <img src="@/assets/images/shop/icon2.png" class="icon-1" />
                          </template>
                          <van-collapse v-model="activeNames" :border="false">
                            <van-collapse-item :name="it.key" class="items-one" v-for="(it, index) in ite.children_list"
                              :key="index">
                              <template #title>
                                <div class="title3">
                                  {{ it.name }}
                                  <div v-if="audition(it)" class="audition-box">
                                    <svg class="my-color-class" width="7px" height="8px" viewBox="0 0 7 8" version="1.1"
                                      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                      <g id="页面-1">
                                        <g id="学习目录1.0.4" transform="translate(-141.000000, -582.000000)">
                                          <g id="内容" transform="translate(0.000000, 142.000000)">
                                            <g id="5" transform="translate(16.000000, 274.000000)">
                                              <g id="章3" transform="translate(12.000000, 160.000000)">
                                                <g id="试听标签" transform="translate(109.000000, 2.000000)">
                                                  <g id="icon/试听" transform="translate(4.000000, 4.000000)">
                                                    <rect id="矩形-3227" opacity="0" x="0" y="0" width="7" height="8">
                                                    </rect>
                                                    <path
                                                      d="M4.79999979,2.56666664 L6.54999991,4.89999998 C6.88137077,5.34182777 6.79182774,5.96862912 6.34999995,6.29999998 C6.17690377,6.42982212 5.96637015,6.5 5.74999992,6.5 L2.24999992,6.5 C1.69771517,6.5 1.24999992,6.05228475 1.24999992,5.5 C1.24999992,5.2836298 1.32017779,5.07309619 1.44999991,4.90000002 L3.19999979,2.56666669 C3.53137063,2.12483888 4.15817198,2.03529581 4.59999979,2.36666665 C4.67580546,2.4235209 4.74314554,2.49086098 4.79999979,2.56666664 Z"
                                                      id="多边形-131"
                                                      transform="translate(4.000000, 4.000000) rotate(90.000000) translate(-4.000000, -4.000000) ">
                                                    </path>
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                    试听
                                  </div>
                                </div>
                              </template>
                              <template #right-icon>
                                <img src="@/assets/images/shop/icon3.png" class="icon-1" />
                              </template>
                              <div class="chapter-list">
                                <div class="chapter-item" v-for="(i, index) in it.children_list" :key="index">
                                  <img src="@/assets/images/shop/icon20.png" class="icon-4"
                                    v-if="i.item_type == 'live'" />
                                  <img src="@/assets/images/shop/icon4.png" class="icon-4"
                                    v-if="i.item_type == 'vod'" />
                                  <img src="@/assets/images/shop/icon19.png" class="icon-4"
                                    v-if="i.item_type == 'exercise'" />
                                  <img src="@/assets/images/shop/icon21.png" class="icon-4"
                                    v-if="i.item_type == 'exam'" />
                                  <img src="@/assets/images/shop/icon18.png" class="icon-4"
                                    v-if="i.item_type == 'recitation'" />
                                  <div class="text-s">
                                    <div class="text">{{ i.name }}</div>
                                    <div v-if="audition(i)" class="audition-box">
                                      <svg class="my-color-class" width="7px" height="8px" viewBox="0 0 7 8"
                                        version="1.1" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <g id="页面-1">
                                          <g id="学习目录1.0.4" transform="translate(-141.000000, -582.000000)">
                                            <g id="内容" transform="translate(0.000000, 142.000000)">
                                              <g id="5" transform="translate(16.000000, 274.000000)">
                                                <g id="章3" transform="translate(12.000000, 160.000000)">
                                                  <g id="试听标签" transform="translate(109.000000, 2.000000)">
                                                    <g id="icon/试听" transform="translate(4.000000, 4.000000)">
                                                      <rect id="矩形-3227" opacity="0" x="0" y="0" width="7" height="8">
                                                      </rect>
                                                      <path
                                                        d="M4.79999979,2.56666664 L6.54999991,4.89999998 C6.88137077,5.34182777 6.79182774,5.96862912 6.34999995,6.29999998 C6.17690377,6.42982212 5.96637015,6.5 5.74999992,6.5 L2.24999992,6.5 C1.69771517,6.5 1.24999992,6.05228475 1.24999992,5.5 C1.24999992,5.2836298 1.32017779,5.07309619 1.44999991,4.90000002 L3.19999979,2.56666669 C3.53137063,2.12483888 4.15817198,2.03529581 4.59999979,2.36666665 C4.67580546,2.4235209 4.74314554,2.49086098 4.79999979,2.56666664 Z"
                                                        id="多边形-131"
                                                        transform="translate(4.000000, 4.000000) rotate(90.000000) translate(-4.000000, -4.000000) ">
                                                      </path>
                                                    </g>
                                                  </g>
                                                </g>
                                              </g>
                                            </g>
                                          </g>
                                        </g>
                                      </svg>
                                      试听
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </van-collapse-item>
                          </van-collapse>
                        </van-collapse-item>
                      </van-collapse>
                    </van-collapse-item>
                  </van-collapse>
                </div>
              </div>
            </template>

            <!-- 非课程表 -->
            <template v-else>
              <div class="goods-catalog">
                <div class="container">
                  <div class="header" v-if="item.listKey === 'teacher'">
                    <span class="title">专业主讲老师</span>
                  </div>

                  <div class="header" v-else-if="item.listKey !== 'content'">
                    <span class="title">{{ item.name }}</span>
                    <!-- <span class="subtitle">{{ item.list.length }}个</span> -->
                  </div>

                  <!-- 介绍页 -->
                  <div class="container-row" v-if="item.listKey == 'content'">
                    <div class="" v-if="goodsData.content.length">
                      <div class="" v-for="(item, index) in goodsData.content" :key="index">
                        <img :src="item.img_url" v-if="item.type == 'img'" class="dk" />
                        <div v-if="item.type == 'video'" class="video-content"
                          :style="{ background: `url(${item.img_url}) center/cover` }">
                          <LivePlayVideo ref="videoPlays" :src="item.video.url" @videoStatus="videoStatus"
                            :poster="item.video.cover_img.url" :autoplay="false" />
                        </div>
                        <div class="bg-box" v-if="item.type == 'tutor'">
                          <div class="audio-box-s">
                            <div class="tutor-top">
                              <div class="tutor-top-left">
                                <img :src="item.tutor.teacher.portrait" class="portrait" />
                                <div class="">
                                  <div class="name">{{ item.tutor.teacher.name }}</div>
                                  <div class="month">{{ teacherTimeFormat(item.tutor.time) }}</div>
                                </div>
                              </div>
                              <div class="tutor-top-right" @click="show = true">
                                查看全部
                                <img src="@/assets/images/shop/icon5.png" />
                              </div>
                            </div>
                            <div class="audios" v-if="
                              item.tutor && item.tutor.tutor_info && item.tutor.tutor_info.audio
                            ">
                              <AudioPlayer :fileUrl="item.tutor.tutor_info.audio.url" @audioPlay="audioPlay"
                                ref="audioPlays"></AudioPlayer>
                            </div>
                            <div class="content-box">
                              <div class="imgbox" v-if="
                                item.tutor && item.tutor.tutor_info && item.tutor.tutor_info.card
                              ">
                                <img :src="tutorCardImgUrl(item)" class="dk" />
                              </div>
                              <div class="text" v-if="item.tutor.tutor_info && item.tutor.tutor_info.text">
                                {{ item.tutor.tutor_info.text || '' }}
                              </div>
                              <div class="content-footer">
                                <div class="items-s" @click="show = true">
                                  <img src="@/assets/images/shop/icon15.png" class="dk" />
                                  回复老师
                                </div>
                                <div class="items-s" @click="show = true">
                                  <img src="@/assets/images/shop/icon14.png" class="dk" />
                                  好的
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 老师板块 -->
                  <div class="catalog-teacher-list" v-if="item.listKey == 'teacher' && lecturerList.length > 0">
                    <TeacherList :list="lecturerList" />
                  </div>
                  <div class="header" style="display: flex; align-items: center"
                    v-if="item.listKey === 'teacher' && goodTeachList && goodTeachList.length > 0">
                    <span class="title">优秀班主任</span>
                  </div>
                  <!-- 老师板块 -->
                  <div class="catalog-teacher-list"
                    v-if="item.listKey == 'teacher' && goodTeachList && goodTeachList.length > 0">
                    <TeacherList :list="goodTeachList" />
                  </div>
                </div>
              </div>
            </template>
          </template>
        </van-tab>
      </van-tabs>
    </div>

    <van-overlay :show="show" @click="show = false" z-index="999">
      <div class="wrapper wrapper-flex" @click.stop>
        <div class="pop-box">
          <img src="@/assets/images/shop/icon13.png" class="dk close-img" @click="show = false" />
          <img src="@/assets/images/shop/icon12.png" class="dk app-img" />
          <div class="pop-btn" @click="buy" v-if="!is_buy">报名加入</div>
          <OpenApp v-else unitKey="Advanced" :options="{ project_no: goodsData.no }" style="width: 100%">
            <div class="pop-btn">打开APP</div>
          </OpenApp>
        </div>
      </div>
    </van-overlay>

    <!-- 侧边打开APP悬浮按钮(停售且未购买时不显示) -->
    <SideOpenApp unitKey="Advanced" :options="{ project_no: goodsData.no }" v-if="goodsData.status !== 5" />

    <!-- 打开app方法调用 -->
    <FooterOpenApp ref="footer_open_app" :name="getCurrentBrand.name" schemaUnitKey="Advanced" style="display: none" />

    <!-- 底部按钮价格 -->
    <GoodsButtonPrice :goodsData="goodsData" :unitName="unitName" :currentSpecs="currentSpecs"
      :productCase="productCase" :offlineProduct="offlineProduct" :titleObj="titleObj">
      <a v-if="goodsCustomerUrl" class="kefu" :href="goodsCustomerUrl">
        <img src="@/assets/images/goods/kefu.png" class="icon" />
        <p class="text">客服</p>
      </a>
      <!-- 已购买 -->
      <template v-if="is_buy">
        <OpenApp unitKey="Advanced" :options="{ project_no: goodsData.no }" style="width: 100%">
          <van-button round type="primary" class="open-button">打开APP学习</van-button>
        </OpenApp>
      </template>

      <!-- 未购买 -->
      <template v-else>
        <!-- 该课程已停售 -->
        <template v-if="goodsData.status === 5">
          <van-button :disabled="true" round type="primary" class="open-button">已停售</van-button>
        </template>
        <!-- 非会员商品 -->
        <template v-else>
          <!-- 普通课程 -->
          <van-button round type="primary" class="open-button" @click="buy">
            <span style="margin-right: 0.16rem">
              ¥{{ clearPriceZero(goodsData.product.price) }}
            </span>
            报名加入
          </van-button>
        </template>
      </template>
    </GoodsButtonPrice>
  </div>
</template>

<script>
import catalogList from '@/components/Goods/CatalogList'
import specsAction from '@/components/Goods/SpecsAction'
import FooterOpenApp from '@/components/FooterOpenApp.vue'
import goodsDetailInfo from '@/components/Goods/GoodsDetailInfo.vue'
import FooterButtonBuy from '@/components/FooterButtonBuy'

import { getAdvclassDetailApi, getDirlApi } from '@/api/guide/detail'
import { addFreeVirtualGoods } from '@/api/order'
import mixinGoodsOffline from '@/views/goods/mixins/goodsOffline'
import mixinGoodsCommon from '@/views/goods/mixins/goodsCommon'
import mixinDeviceToPc from '@/views/goods/mixins/deviceToPc'

import GoodsInfoTitle from '@/components/GoodsInfo/GoodsInfoTitle.vue'
import GoodsInfoCell from '@/components/GoodsInfo/GoodsInfoCellItem.vue'
import GoodsInfoCellSpecs from '@/components/GoodsInfo/GoodsInfoCellSpecs.vue'
import GoodsInfoCellItem from '@/components/GoodsInfo/GoodsInfoCellItem.vue'
import GoodsInforLabels from '@/components/GoodsInfo/GoodsInfoLabels.vue'
import GoodsButtonPrice from '@/components/shop/GoodsButtonPrice.vue'
import SideOpenApp from '@/components/SideOpenApp.vue'
import TeacherList from '@/components/Course/TeacherList.vue'
import OpenApp from '@/components/OpenApp.vue'
import GoodsLiveTips from '@/components/Goods/GoodsLiveTips.vue'
import { isWXBrowser } from '@/utils/browser'
import { formatDate } from '@/utils/date'
import AudioPlayer from '@/components/Audio/index.vue'
import LivePlayVideo from '@/components/Video/LivePlayVideo.vue'
export default {
  components: {
    FooterButtonBuy,
    catalogList,
    specsAction,
    FooterOpenApp,
    goodsDetailInfo,
    GoodsInfoTitle,
    GoodsInfoCell,
    GoodsInfoCellSpecs,
    GoodsInfoCellItem,
    GoodsInforLabels,
    GoodsButtonPrice,
    SideOpenApp,
    TeacherList,
    GoodsLiveTips,
    AudioPlayer,
    OpenApp,
    LivePlayVideo,
  },
  mixins: [mixinGoodsOffline, mixinGoodsCommon, mixinDeviceToPc],
  data() {
    return {
      goodsThreePoint: this.$imageURL.goodsThreePoint,
      isSpecsAction: false, //是否显示勾选规格按钮

      // 单元名称 course
      unitName: 'Advanced',
      unitNameList: {
        // 课程
        Advanced: {
          request: getAdvclassDetailApi,
          schemaUnitKey: 'Advanced',
          goodsAddRequestType: 'Advanced',
          openAppText: '开始学习',
          title: '：精品课程分享',
          freeButtonText: '添加课程',
        },
      },

      goodsData: {}, // 商品数据

      tabsList: [], // tab列表数据
      tabsActiveIndex: 0, //tab选中下标

      // 商品规格
      productCase: { case: [] },
      pageLoadingComplete: false,
      isMultipleSpecsOnceSelect: false, //多规格商品是否选中过一次

      // 是否禁用按钮
      isDisableButton: false,

      // 是否购买
      is_buy: false,

      showWxBuyButton: true,
      tab_active: 0,
      activeNames: [],
      bg_show: false,
      show: false,
      lecturerList: [],
      goodTeachList: [],
      learnList: [],
    }
  },

  computed: {
    tutorCardImgUrl() {
      return (item) => {
        return item.tutor.tutor_info.card.data.img_url
      }
    },
    teacherTimeFormat() {
      return (time) => {
        let vodTime = formatDate(time)
        return vodTime.year + '/' + vodTime.month + '/' + vodTime.day + ' ' + vodTime.hm
      }
    },
    // 当前单元
    currentUnit() {
      return this.unitNameList[this.unitName]
    },
    // 当前规格
    currentSpecs() {
      let caselist = this.productCase.case || []
      let result = caselist.filter((item) => {
        return item.default === 1
      })
      return result[0]
    },
    // 是否是多规格
    isMultipleSpecs() {
      return this.productCase.case.length > 1
    },
    // 免费商品
    isFreeGoods() {
      return this.goodsData?.usability === 'free'
    },
    // 指定给会员的商品
    isVipGoods() {
      return this.goodsData?.usability === 'membership'
    },
    // 是否可以使用会员价购买
    isVipPricePower() {
      return !!this.goodsData.is_membership_price
    },
    // 免费会员购买
    isFreeVipBuy() {
      return this.isVipGoods && !!this.goodsData.is_buy_membership
    },
    // 按钮文案
    buttonText() {
      return this.isFreeGoods ? this.currentUnit.freeButtonText : '立即购买'
    },
    // 商品客服链接
    goodsCustomerUrl() {
      // 先取出客服列表 & 客户信息（避免重复?.）
      const serviceList = this.goodsData?.customer_service || []
      const customerInfo = this.goodsData?.customer_info

      // 优先取客服第一条，没有则取客户信息里的url
      return serviceList.length > 0
        ? serviceList[0].value
        : customerInfo?.url
    },
    // 商品标题
    goodInforTitle() {
      if (this.offlineProduct && this.offlineProduct.case_type == 'group') {
        return this.titleObj.title
      } else {
        return this.goodsData.name
      }
    },
    isShowGoodsQQ() {
      return this.goodsData?.qq && this.goodsData.qq.length > 0
    },
    goodsCourseDescMaxLength() {
      let max = 2
      if (!this.goodsData.course_desc) {
        return max
      }
      this.goodsData.course_desc.list.map((item) => {
        if (item.item.length > max) {
          max = item.item.length
        }
      })

      return max
    },
  },

  created() {
    document.title = this.getCurrentBrand.name + this.currentUnit.title
    this.checkURLBuyState()
    this.getGoodsDetail()
    this.checkIsAPP()
    this.setupRecommendCode(this.$route.query, { rcode_range: 'advclass' })
  },
  methods: {
    audition(item) {
      // if (item.key) {
      //     if (!this.activeNames.includes(item.key)) {
      //         if (item.audition == 1) {
      //             return true
      //         }
      //     }
      // } else {
      //     if (item.audition == 1) {
      //         return true
      //     } else {
      //         return false
      //     }
      // }
      return false
    },
    //判断是否是app
    checkIsAPP() {
      if (window?.tikuWeb?.setShareHtml) {
        this.openApps()
        setTimeout(() => {
          window.history.back()
        }, 1500)
        return true
      }
      if (window?.webkit?.messageHandlers?.canLoadShare) {
        this.openApps()
        setTimeout(() => {
          window.close()
        }, 1500)
        return true
      }
      return false
    },
    // 打开app
    openApps() {
      // 会员时保留当前购买状态
      if (!this.isVipGoods) {
        this.is_buy = true
      }
      this.pageLoadingComplete = true
      setTimeout(() => {
        this.$refs.footer_open_app.openApp()
      })
    },
    // 获取商品详情
    getGoodsDetail() {
      let requestGoods = this.currentUnit.request,
        params = this.routeFixedParam()

      params.no = this.$route.query.no
      // 商品请求
      requestGoods({ ...params }).then((res) => {
        if (res.status == 1 || res.status == 6001) {
          // 页面加载完成
          this.pageLoadingComplete = true

          let resData = res.data || {}
          let product = resData.product || {}

          // 当页面状态是未购买的时  刷新购买状态
          if (!this.is_buy) {
            this.updateGoodsBuySate(resData.is_buy)
          }
          /*============================= start 线下商品======================*/
          if (product.case_type == 'group') {
            this.offlineProduct = product
            this.getCopyTitle(product.case)
            this.copyTitleObj['title'] = product.name
            this.titleObj['title'] = product.name
            this.disableUpdate()
          }
          /*============================= end 线下商品======================*/
          // 初始化商品规格数据
          this.updateGoodsProduct(product)
          // 格式化商品数据
          this.dataGoodsFormatMiddle(resData)
          // 设置分享卡片
          this.setShareCard()
          // 跳转登录
        } else {
          this.$router.replace({
            name: 'emptyContent',
            query: { url: this.$route.fullPath },
          })
        }
      })
    },

    // 设置分享卡片
    setShareCard() {
      const shareOpiton = this.goodsData?.share_info || {}
      this.$util.setShare({
        title: shareOpiton.title || '',
        desc: shareOpiton.desc || '',
        link: window.location.href,
        imgUrl: shareOpiton.image || this.getCurrentBrand.imageLogoURL,
      })
    },

    // 商品数据格式化 中间件
    dataGoodsFormatMiddle(data) {
      let dataGoods = {}
      dataGoods = data
      this.dataGoodsFormat(dataGoods)
    },
    tabsListFactory(dataKeyName, name, listKey) {
      return { dataKeyName, name, listKey }
    },
    // 商品数据格式化
    dataGoodsFormat(sourceData) {
      let tabsListFactory = this.tabsListFactory,
        data = sourceData,
        tabsList = [],
        contentList = [tabsListFactory('content', '班级介绍', 'content')]
      contentList.push(tabsListFactory('first_learn_content', '学习目录', 'first_learn_content'))
      contentList.push(tabsListFactory('teacher', '双师服务', 'teacher'))
      contentList.forEach(function (item) {
        let list = data[item.dataKeyName]
        if (list && list.length > 0) {
          tabsList.push({
            name: item.name,
            listKey: item.listKey,
            list: list,
          })
        }
      })
      this.tabsList = tabsList
      this.goodsData = data
      if (this.goodsData.first_learn_content.length) {
        this.goodsData.first_learn_content.map((item, index) => {
          if (item.default_expand == 1) {
            this.tab_active = index
          }
        })
      }
      if (this.goodsData.teacher.length) {
        this.lecturerList = this.goodsData?.teacher[0]?.list
        this.goodTeachList = this.goodsData?.teacher[1]?.list
      }

      if (this.goodsData.child_learn_content.length) {
        this.learnList = this.goodsData.child_learn_content
        this.learnList.forEach((item) => {
          if (Array.isArray(item.children_list) && item.children_list.length > 0) {
            this.processItem(item)
          }
        })
        this.auditionMark()
        if (
          this.goodsData.first_learn_content.length &&
          this.goodsData.first_learn_content[this.tab_active].default_expand == 1
        ) {
          this.activeNames.push(this.learnList[0].key)
          this.activeNames.push(this.learnList[0].children_list[0].key)
          this.activeNames.push(this.learnList[0].children_list[0].children_list[0].key)
        }
      }
    },

    // 触发规格勾选
    specsTriggerAction() {
      this.isSpecsAction = !this.isSpecsAction
      this.isMultipleSpecsOnceSelect = true
    },
    // 更改规格
    changeSpecsItem(list) {
      this.productCase.case = list
    },

    // 检查url 购买状态
    checkURLBuyState() {
      if (this.$route.query.buyState !== undefined) {
        // 更新购买状态 已购买
        this.updateGoodsBuySate(true)
      }
    },

    // 添加免费商品
    addFreeGoods() {
      let param = this.routeFixedParam()
      param.item_no = this.$route.query.no
      param.pay_type = 'free'
      if (this.currentUnit.goodsAddRequestType) {
        param.type = this.currentUnit.goodsAddRequestType
      }

      if (this.isFreeVipBuy) {
        param.pay_type = 'membership'
      }

      addFreeVirtualGoods(param).then((res) => {
        // 添加成功
        if (res.status === 1) {
          this.$toast('添加成功')
          this.getGoodsDetail()
          return
        }
        this.$toast(res.message)
      })
    },

    // 检查是否为免费商品
    checkFreeGoods() {
      // 免费课程直接添加
      if (this.isFreeGoods) {
        this.addFreeGoods()
        return true
      }
    },
    // 检查是否为会员免费购买商品
    checkVipFreeBuyGoods() {
      if (this.isFreeVipBuy) {
        this.addFreeGoods()
        return true
      }
    },
    // 检查是否为身份商品
    checkUsabilityGoods() {
      let query = this.routeFixedParam()

      // 课程类型为身份时，跳转身份详情页
      if (this.goodsData.usability === 'identity') {
        query.no = this.goodsData.identity.no
        this.$router.push({
          path: '/identity/detail',
          query,
        })
        return true
      }
    },

    // 点击购买时执行的方法
    buy() {
      if (this.checkIsAPP()) {
        return false
      }
      if (this.checkUserNotLogin()) {
        return false
      }
      if (this.checkFreeGoods()) {
        return false
      }
      if (this.checkVipFreeBuyGoods()) {
        return false
      }
      if (this.checkUsabilityGoods()) {
        return false
      }

      let o = {}
      o.product_no = this.productCase?.no
      o.case_id = this.currentSpecs.id
      o.count = 1
      this.goPay([o])
    },
    // 直播中按钮点击
    onGoodsLiveClick(liveInfor) {
      if (liveInfor.live_status === 0) {
        this.$toast('直播未开始')
        return false
      }
      if (liveInfor.live_status === 2) {
        this.$toast('直播已结束')
        return false
      }
      if (liveInfor.live_status === 3) {
        this.$toast('请前往APP观看回放课程')
        return false
      }

      const query = this.routeFixedParam()
      query.course_no = this.$route.query.no
      query.id = liveInfor.id
      this.$router.push({
        path: '/live/play',
        query,
      })
    },
    tabChange(key, index) {
      this.tab_active = index
      this.changeCatalog(key)
    },
    collapseChange() {
      if (this.activeNames.length) {
        const foundElement = this.activeNames.find((item) => item == 1)
        if (foundElement !== undefined) {
          this.bg_show = false
        } else {
          this.bg_show = true
        }
      } else {
        this.bg_show = true
      }
    },
    changeCatalog(key) {
      let params = {
        no: this.$route.query.no,
        subject_key: key,
        brand: this.$route.query.brand,
      }
      getDirlApi({ ...params }).then((res) => {
        this.learnList = res.data
        this.learnList.forEach((item) => {
          if (Array.isArray(item.children_list) && item.children_list.length > 0) {
            this.processItem(item)
          }
        })
        this.auditionMark()
        if (
          res.data.length &&
          this.goodsData.first_learn_content[this.tab_active].default_expand == 1
        ) {
          this.activeNames.push(this.learnList[0].key)
          this.activeNames.push(this.learnList[0].children_list[0].key)
          this.activeNames.push(this.learnList[0].children_list[0].children_list[0].key)
        }
      })
    },
    //给试听内容父级添加标记
    auditionMark() {
      this.learnList.forEach((item) => {
        if (item.children_list && item.children_list.length > 0) {
          for (let i = 0; i < item.children_list.length; i++) {
            const child = item.children_list[i]
            if (child.children_list && child.children_list.length > 0) {
              for (let j = 0; j < child.children_list.length; j++) {
                const grandchild = child.children_list[j]
                if (grandchild.children_list && grandchild.children_list.length > 0) {
                  for (let k = 0; k < grandchild.children_list.length; k++) {
                    const greatGrandchild = grandchild.children_list[k]
                    if (greatGrandchild.audition == 1) {
                      item.audition = 1
                      child.audition = 1
                      grandchild.audition = 1
                      break // 如果没有使用 break，它会继续检查 greatGrandchild 的所有兄弟节点。如果希望一旦找到一个 audition 为1就停止，请加入这个 break。
                    }
                  }
                }
              }
            }
          }
        }
      })
    },
    //递归筛选直播录播试学内容
    processItem(item) {
      if (Array.isArray(item.children_list) && item.children_list.length > 0) {
        item.children_list.forEach((child) => {
          if (child.children_list && child.children_list.length > 0) {
            this.processItem(child)
          }
          // if (child.audition === 1) {
          //     item.audition = true;
          // }
          if (child.audition === 1 && child.item_type !== 'live' && child.item_type !== 'vod') {
            child.audition = 0
          }
        })
      }
    },
    videoStatus(e) {
      if (e) {
        this.$refs.audioPlays[0].pause()
      }
    },
    audioPlay(e) {
      if (e) {
        this.$refs.videoPlays[0].pause()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$mainColor: var(--main-color);

/deep/ .hideTabNav {
  .van-tabs__wrap {
    display: none !important;
  }
}

/deep/ .van-tabs__nav {
  padding: 0 0.53rem;
}

.goods {
  &-card {
    padding-top: 0.25rem;
    padding-bottom: 0.5rem;

    &+& {
      border-top: 0.01rem solid #f7f8fa;
    }

    &-title {
      font-size: 0.48rem;
      line-height: 0.8rem;
      color: $color_black;
      font-weight: bold;
      margin-bottom: 0.3rem;
    }
  }

  &-catalog {
    border-bottom: 0.2rem solid #f7f8fa;
    background: #fff;

    .header {
      padding-top: 0.5rem;
      margin-bottom: -0.1rem;

      .title {
        font-size: 0.4rem;
        font-weight: bold;
      }

      .subtitle {
        font-size: 0.32rem;
        color: #919499;
        margin-left: 0.2rem;
      }
    }

    .image {
      display: block;
      width: 100%;
    }
  }
}

.van-tab__pane {
  &:nth-last-child(1) {
    min-height: 90vh;
    background-color: #fff;
  }
}

.van-tab__pane:nth-last-child(1) {
  .goods-catalog {
    border: none;
  }
}

.container-buy {
  .goods-catalog {
    border: none;
  }
}

.specs-action {
  padding-bottom: 0.6rem;

  .van-action-sheet__header {
    padding: 0.59rem 0;
    font-size: 0.48rem;
    line-height: 1;
    color: #18191a;
    text-align: left;
    font-weight: bold;
  }
}

.course-count {
  &-item {
    .text {
      line-height: 0.37rem;
      font-size: 0.32rem;
      color: #666666;

      .icon {
        display: inline-block;
        width: 0.37rem;
        transform: translateY(0.05rem);
        margin-right: 0.2rem;
      }

      &+.text {
        margin-left: 0.5rem;
      }
    }
  }
}

/deep/ .van-sticky.van-sticky--fixed {
  @include maxWidth();
}

.buy-button {
  z-index: 100;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1.65rem;
  padding-top: 0.24rem;
  padding-bottom: 0.24rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-top: 0.01rem solid #eee;
  background-color: #fff;
  @include maxWidth();

  .kefu {
    .icon {
      width: 0.53rem;
      margin-left: 0.05rem;
    }

    width: 1.7rem;
    height: 1rem;
  }
}

/deep/ .jbc-tabs {
  border-top: 0.21rem solid #f7f8fa;

  .van-tabs__wrap {
    height: 1.6rem;

    .van-tabs__nav {
      // padding-top: 0.1rem;
      padding-bottom: 0;
      box-sizing: border-box;
    }
  }

  .van-tabs__line {
    bottom: 0.2rem;
  }
}

.container-wrapper {
  padding-bottom: 1.7rem;
  min-height: 100vh;
  background-color: #fff;
  box-sizing: border-box;

  &.container-buy {
    .van-tab__pane {
      &:nth-last-child(1) {
        min-height: auto;
      }
    }
  }
}

/deep/ .imgBox img {
  max-width: 100%;
}

/*线下课程弹窗*/
.actionContent {
  padding: 0.53rem 0.53rem 1.8rem;
  min-height: 1.65rem;
  overflow: hidden;

  .actionTitle {
    font-size: 0.48rem;
    font-weight: bold;
    line-height: 0.66rem;
    color: #18191a;
    letter-spacing: 5.843277962457472 e-15px;
  }

  .actionPriceMap {
    margin-top: 0.21rem;
    padding-bottom: 0.56rem;
    border-bottom: 0.01rem solid #ebecf0;
    font-size: 0.48rem;
    font-weight: bold;
    line-height: 0.59rem;
    color: #ff6a4d;
    letter-spacing: 5.843277962457472 e-15px;

    .symbol {
      font-size: 16px;
      /*font-weight: 500;*/
    }

    .line {
      margin: 0 4px;
    }
  }

  .typeMap {
    width: 100%;
    max-height: 8.36rem;
    /*margin-top: 0.43rem;*/
    padding-top: 0.43rem;
    overflow-y: scroll;

    .typeList {
      width: 100%;
      margin-bottom: 0.56rem;

      .typeTitle {
        font-size: 0.37rem;
        font-weight: 400;
        line-height: 0.37rem;
        color: #22242e;
        letter-spacing: 5.843277962457472 e-15px;
        margin-bottom: 0.42rem;
        font-family: PingFang SC;
      }

      .typeContent {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .typeItem {
          display: inline-block;
          font-size: 0.35rem;
          font-weight: 400;
          padding: 0.16rem 0.32rem;
          background: #f7f8fa;
          font-family: PingFang SC;
          border-radius: 0.11rem;
          border: 1px solid #f7f8fa;
          margin: 0 0.32rem 0.42rem 0;
          color: #3c3d42;
        }

        .typeItemActive {
          z-index: 1;
          position: relative;
          border-color: $mainColor;
          color: $mainColor;

          &:after {
            z-index: -1;
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: $mainColor;
            opacity: 0.05;
          }
        }

        .typeItemDisable {
          background-color: #f7f8fa;
          border-color: #f7f8fa;
          color: #c2c5cc;
        }
      }

      .typeContentNoWrap {
        flex-direction: column;

        .typeItem {
          width: auto;
          display: inline-block;
        }
      }
    }
  }
}

.goods {
  &-card {
    padding-top: 0.2rem;
    padding-bottom: 0.4rem;

    &+& {
      border-top: 0.01rem solid #f7f8fa;
    }

    &2 {
      padding-top: 0.4rem;
      padding-bottom: 0.4rem;
    }
  }
}

.kefu {
  .icon {
    width: 0.53rem;
    margin-left: 0.05rem;
  }

  width: 1.7rem;
  height: 1rem;
}

.catalog-teacher-list {
  /deep/ .teacher-list {
    white-space: initial;

    li {
      padding: 0.53rem 0;

      &+li {
        // border-top: 0.01rem solid #EBECF0;
      }
    }

    .portrait {
      width: 1.28rem;
      height: 1.28rem;
      margin-right: 0.32rem;
    }

    .name {
      font-size: 0.37rem;
      font-weight: 500;
      color: #3c3d42;
      margin-top: 0.15rem;
    }

    .title {
      font-size: 0.29rem;
      font-weight: 400;
      color: #919499;
    }
  }
}

.goods {
  &-specs {
    &-item {
      display: flex;
      padding: 0.2rem 0;

      .name {
        height: 0.43rem;
        font-size: 0.29rem;
        font-weight: 400;
        color: #c2c5cc;
      }
    }
  }
}

.question-count {
  display: flex;
  margin-bottom: 0.2rem;

  &-item {
    font-size: 0.37rem;
    line-height: 0.35rem;
    color: #919499;
    padding: 0 0.2rem;
    margin-top: 0.4rem;

    &:nth-child(1) {
      padding-left: 0;
    }

    &+& {
      border-left: 1px solid #919499;
    }

    .number {
      font-size: 0.45rem;
      color: #18191a;
      font-weight: bold;
    }
  }
}

.teacher-group {
  display: flex;
  align-items: center;
  height: 0.75rem;
  border-top: 0.01rem solid #ebecf0;
  padding-top: 0.32rem;
  margin-top: 0.6rem;

  .icon {
    width: 0.75rem;
    height: 0.75rem;
    margin-right: 0.2rem;
  }

  .text {
    @include ellipsis;
    width: 5rem;
    font-size: 0.29rem;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 0.48rem;
    color: #666666;
  }

  .button {
    @include flex_center;
    margin-left: auto;
    width: 2.11rem;
    height: 0.64rem;
    background: rgba(var(--main-rgba), 0.05);
    border: 1px solid rgba(var(--main-rgba), 0.5961);
    border-radius: 0.53rem;
    color: var(--main-color);
    font-size: 0.29rem;
  }
}

.coupon-box {
  display: flex;
  padding: 0.14rem 0;

  .name {
    width: 1.92rem;
    font-size: 0.32rem;
    color: #919499;
    line-height: 0.48rem;
  }

  .coupon-list {
    display: flex;
    flex-wrap: wrap;
    flex: 1;

    .coupon-item {
      display: flex;
      margin-right: 0.23rem;
      margin-bottom: 0.23rem;

      .left {
        color: #ff6a4d;
        font-size: 0.29rem;
        background: rgba(255, 106, 77, 0.05);
        border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
        opacity: 1;
        border: 0.01rem solid rgba(255, 106, 77, 0.3);
        padding: 0.06rem 0.11rem;
        border-right: 0;
      }

      .right {
        color: rgba(255, 106, 77, 0.5);
        font-size: 0.29rem;
        background: rgba(255, 106, 77, 0.05);
        border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
        opacity: 1;
        border: 0.01rem solid rgba(255, 106, 77, 0.3);
        padding: 0.06rem 0.11rem;
        border-left: 0;
      }
    }
  }
}

.banner-img {
  img {
    display: block;
  }
}

.goods-infor {
  background: #f7f8fa;
}

.labels-title {
  font-size: 0.32rem;
  padding-bottom: 0.43rem;
  border-bottom: 0.01rem solid #ebecf0;
}

.application-box {
  padding-top: 0.48rem;
  @include flex_between_center;

  .left {
    .money-box {
      @include flex-align;
      @include flex-display;

      .money-f {
        font-size: 0.43rem;
        color: #f57159;

        span {
          font-size: 0.35rem;
        }
      }

      .money-r {
        font-size: 0.32rem;
        color: #c2c5cc;
        text-decoration: line-through;
      }
    }

    .refund-money {
      font-size: 0.32rem;
      color: #919499;
      // margin-top: 0.11rem;
    }
  }

  .right {
    font-size: 0.35rem;
    color: var(--main-color);
    padding: 0.16rem 0.53rem;
    border: 1px solid var(--main-color);
    border-radius: 0.11rem;
  }
}

.bg-box {
  position: relative;
  background: #e8f2ff;
  padding: 0 0.43rem;
  padding-bottom: 0.8rem;
  padding-top: 0.4rem;

  .content-box {
    padding: 0 0.43rem;

    .text {
      font-size: 0.3rem;
      @include ellipsis(3);
      padding: 0.43rem 0;
      border-bottom: 0.01rem solid #ebecf0;
      color: #919499;
    }

    .content-footer {
      display: flex;
      align-items: center;
      padding: 0.43rem 0;

      .items-s {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
        font-size: 0.35rem;
        position: relative;

        &:last-child::after {
          display: none;
        }

        &::after {
          display: block;
          position: absolute;
          content: ' ';
          width: 1px;
          height: 0.32rem;
          background: #ebecf0;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }

        img {
          width: 0.35rem;
          height: 0.35rem;
          margin-right: 0.08rem;
        }
      }
    }
  }

  .audio-box-s {
    // position: absolute;
    // top: 7.31rem;
    // left: 0.43rem;
    // right: 0.43rem;
    background: #ffffff;
    box-shadow: 0rem 0.11rem 0.27rem 0rem rgba(182, 195, 242, 0.2);
    border-radius: 0.21rem;
    // height: 10.65rem;

    .audios {
      padding: 0.43rem;
    }
  }

  // padding-top: 7.31rem;
  // background: url('../../assets/images/shop/bg1.png') center/cover;
}

.dk {
  display: block;
  width: 100%;
}

.tab-box {
  height: 1.06rem;
  overflow: hidden;
  margin-top: 0.8rem;

  .tab-lists {
    overflow-x: auto;
    overflow-y: hidden;
    box-sizing: content-box;
    height: 100%;
    display: flex;
    padding-left: 0.43rem;
    white-space: nowrap;

    &::-webkit-scrollbar {
      display: none;
    }

    .tab-list-item {
      font-size: 0.35rem;
      color: #666;
      background: #f7f8fa;
      border-radius: 0.11rem;
      display: table;
      padding: 0 0.3rem;
      margin-right: 0.16rem;
      position: relative;
      height: 0.96rem;
      min-width: 1.93rem;
      line-height: 0.96rem;
      text-align: center;

      &.active {
        background: var(--main-color);
        color: #fff;

        &::after {
          position: absolute;
          display: block;
          content: ' ';
          bottom: -3px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-top: 4px solid var(--main-color);
        }
      }
    }
  }
}

:deep(.van-collapse-item__title--expanded img) {
  transform: rotate(-180deg) !important;
}

:deep(.van-collapse-item__title img) {
  transform: rotate(0deg) translateZ(0);
  transition: transform var(--van-collapse-item-duration);
}

.icon-1 {
  width: 0.43rem;
  height: 0.43rem;
  margin-top: 0.08rem;
}

:deep.border-s {
  border: 0.01rem solid #ebecf0;
  border-radius: 0.21rem;
  margin-bottom: 0.27rem;

  .van-collapse-item {
    border-radius: 0.21rem;

    .van-cell {
      // border-radius: 0.21rem;
      // padding-top: 0.43rem;
      // padding-bottom: 0.43rem;
      padding: 0.3rem;
    }
  }
}

:deep.items {
  border-bottom: 0.01rem solid #ebecf0;

  &:last-child {
    border: 0;

    .van-cell {
      padding-bottom: 0;
    }
  }

  .van-cell {
    padding-left: 0 !important;
    padding-right: 0 !important;

    border-radius: 0;
  }

  .van-collapse-item__title::after {
    right: 0;
    display: none;
  }

  .van-collapse-item__content {
    padding-right: 0;
    border-radius: 0 0 0.21rem 0.21rem;
    padding-bottom: 0;
  }
}

:deep .van-cell {
  border-radius: 0.21rem;
}

:deep(.van-collapse-item__content) {
  border-radius: 0.21rem;
  padding-top: 0;
}

:deep.van-collapse-item__wrapper {
  border-radius: 0.21rem;
}

:deep.items-one {
  .van-cell {
    padding-left: 0;
    padding-right: 0;
    border-radius: 0;
  }

  .van-collapse-item__content {
    padding-right: 0;
    padding-left: 0;
  }
}

.title1 {
  font-size: 0.4rem;
  color: #3c3d42;
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  padding-right: 0.2rem;
}

.title2 {
  font-size: 0.37rem;
  color: #666;
  display: flex;
  align-items: center;
  @include ellipsis(2);
  padding-right: 0.2rem;
}

.title3 {
  font-size: 0.32rem;
  color: #919499;
  display: flex;
  align-items: center;
  @include ellipsis(2);
  padding-right: 0.2rem;
}

.custom-panel {
  background-color: #f0f0f0;
}

:deep.bg_gray {
  background: #f7f8fa;
  border-color: #f7f8fa;

  .van-cell {
    background: #f7f8fa;
  }

  .van-collapse-item__content {
    background: #f7f8fa;
  }
}

.van-button::before {
  background-color: transparent !important;
}

:deep(.van-cell--clickable:active) {
  background: transparent;
}

.chapter-list {
  .chapter-item {
    display: flex;
    // align-items: center;
    padding: 0.27rem 0;
    margin-bottom: 0.27rem;

    .icon-4 {
      width: 0.4rem;
      height: 0.4rem;
    }

    .text-s {
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0;
      // margin-top: rem;
      margin-top: -0.01rem;
    }

    .text {
      font-size: 0.32rem;
      padding-left: 0.21rem;
      flex: 1;
      min-width: 0;
      @include ellipsis(2);
      padding-right: 0.2rem;
      color: #3c3d42;
      // line-height: 1em;
    }

    &:last-child {
      margin-bottom: 0;
      // padding-bottom: 0;
      border-bottom: 0;
    }
  }
}

.collapse-list {
  padding-top: 0.43rem;
}

.audition-img {
  // width: 0.67rem;
  // height: 0.35rem;
  background: var(--main-color);
  color: #fff;
  font-size: 0.27rem;
  padding: 0.05rem 0.15rem;
  border-radius: 20px 20px 20px 0;
  position: absolute;
  top: -0.2rem;
  right: -0.78rem;
  z-index: 2;
  transform: scale(0.7);
}

::deep.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}

/deep/.van-collapse-item__title--expanded::after {
  display: none !important;
}

/deep/ .van-collapse-item--border::after {
  display: none !important;
}

/deep/.van-tab__text--ellipsis {
  overflow: inherit;
}

.wrapper-flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .pop-box {
    position: relative;

    .close-img {
      width: 0.64rem;
      height: 0.64rem;
      position: absolute;
      top: -0.91rem;
      right: 0;
    }

    .app-img {
      width: 8rem;
      height: 9.44rem;
      margin: 0 auto;
    }

    .pop-btn {
      position: absolute;
      bottom: 0.85rem;
      left: 0.85rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 6.29rem;
      height: 1.2rem;
      font-size: 0.37rem;
      color: #fff;
      border-radius: 0.61rem;
      background: #649dfa;
    }
  }
}

.label-line {
  font-size: 0.32rem;
  color: #649dfa;
  padding: 0.03rem 0.11rem;
  border: 1px solid rgba(100, 157, 250, 0.3);
  background: rgba(100, 157, 250, 0.05);
  border-radius: 0.11rem;
  margin-left: 0.16rem;
}

.tutor-top {
  display: flex;
  justify-content: space-between;
  padding: 0 0.43rem;
  padding-top: 0.43rem;

  .tutor-top-left {
    display: flex;
    align-items: center;

    .portrait {
      width: 1.07rem;
      height: 1.07rem;
      border-radius: 50%;
      margin-right: 0.19rem;
    }

    .name {
      font-size: 0.43rem;
      color: #3c3d42;
    }

    .month {
      font-size: 0.27rem;
      color: #c2c5cc;
      margin-top: 0.05rem;
    }
  }

  .tutor-top-right {
    font-size: 0.32rem;
    color: #919499;
    display: flex;
    align-items: center;

    img {
      width: 0.32rem;
    }
  }
}

.app-advert .open-button {
  width: 100% !important;
}

.van-button--round {
  border-radius: 0.16rem;
}

.goods-card {
  padding-top: 0.5rem;
  border-radius: 0.21rem 0.21rem 0 0;
  background: #fff;
}

.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border: 0 !important;
}

.audition-box {
  .my-color-class {
    width: 0.19rem;
    height: 0.21rem;
    margin-right: 0.08rem;
    fill: var(--main-color) !important;
    color: var(--main-color);
  }

  font-size: 0.27rem;
  color: var(--main-color);
  background: rgba(var(--main-rgba), 0.05);
  border-radius: 0.08rem;
  padding: 0.11rem;
  margin-left: 0.16rem;
  line-height: 1em;
}

.video-content {
  padding: 1.07rem 0.43rem;
}

/deep/.video-js {
  border-radius: 0.21rem;
}

/deep/.video-js .vjs-tech {
  border-radius: 0.21rem;
}

:deep(.vjs-poster) {
  border-radius: 0.21rem !important;
}

:deep(.van-cell) {
  line-height: 1.5 !important;
}
</style>
